/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */

import ICommonTranslationSearchInput from '../../types/common/searchInput';

const initTranslationSearchInput: ICommonTranslationSearchInput = {
    placeholder: '',
};

export default initTranslationSearchInput;
